<main class="c-main wow-consulta ticket-kanban">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>confirmation_number</mat-icon></div>
          <mat-card-title>Tickets</mat-card-title>
        </div>

        <div class="ticket-kanban__toolbar">
          <div class="ticket-kanban__resumo">
            <div class="ticket-kanban__kpi">
              <span class="ticket-kanban__kpi-valor">{{ resumo.abertos }}</span>
              <span class="ticket-kanban__kpi-label">Abertos</span>
            </div>
            <div class="ticket-kanban__kpi ticket-kanban__kpi--atraso">
              <span class="ticket-kanban__kpi-valor">{{ resumo.atrasados }}</span>
              <span class="ticket-kanban__kpi-label">Atrasados</span>
            </div>
            <div class="ticket-kanban__kpi ticket-kanban__kpi--ok">
              <span class="ticket-kanban__kpi-valor">{{ resumo.concluidosSemana }}</span>
              <span class="ticket-kanban__kpi-label">Concluídos (7 dias)</span>
            </div>
          </div>

          <div class="ticket-kanban__atalhos">
            <mat-slide-toggle [(ngModel)]="filtroMeusTickets" (change)="onFiltroChange()">
              Meus tickets
            </mat-slide-toggle>
            <mat-form-field appearance="fill" class="ticket-kanban__filtro-segmento">
              <mat-label>Segmento</mat-label>
              <mat-select [(ngModel)]="filtroSegmento" (selectionChange)="carregar(true)">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let s of segmentos" [value]="s.codigo">{{ s.nome || s.codigo }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div #board class="ticket-kanban__board" *ngIf="!carregando; else loading" cdkDropListGroup>
          <section class="ticket-kanban__coluna"
            *ngFor="let coluna of colunas"
            [attr.data-coluna-id]="coluna.id"
            [class.ticket-kanban__coluna--wip]="atingiuWip(coluna)"
            [class.ticket-kanban__coluna--wip-over]="ultrapassouWip(coluna)">
            <header class="ticket-kanban__coluna-header">
              <div class="ticket-kanban__coluna-titulo">
                <h3>{{ coluna.titulo }}</h3>
                <small *ngIf="coluna.limiteWip" class="ticket-kanban__wip-hint"
                  [matTooltip]="'Limite WIP: ' + coluna.limiteWip">
                  WIP {{ coluna.tickets.length }}/{{ coluna.limiteWip }}
                </small>
              </div>
              <span class="ticket-kanban__count"
                [class.ticket-kanban__count--wip]="atingiuWip(coluna)">
                {{ coluna.tickets.length }}
              </span>
            </header>

            <div class="ticket-kanban__lista"
              cdkDropList
              [cdkDropListData]="coluna.tickets"
              (cdkDropListDropped)="drop($event, coluna)">

              <article class="ticket-kanban__card"
                *ngFor="let ticket of coluna.tickets"
                cdkDrag
                (cdkDragStarted)="onDragStarted()"
                (cdkDragEnded)="onDragEnded()"
                [cdkDragDisabled]="movendo || !!movimentoPendente"
                [style.borderLeftColor]="corCategoria(ticket.tipo)"
                [class.ticket-kanban__card--atrasado]="estaAtrasado(ticket)"
                (click)="onCardClick(ticket)">
                <div class="ticket-kanban__card-preview" *cdkDragPreview
                  [style.borderLeftColor]="corCategoria(ticket.tipo)">
                  #{{ ticket.id }} — {{ ticket.menu || 'Sem assunto' }}
                </div>
                <div class="ticket-kanban__card-placeholder" *cdkDragPlaceholder></div>

                <div class="ticket-kanban__card-topo">
                  <strong>#{{ ticket.id }}</strong>
                  <span class="ticket-kanban__badge"
                    [style.background]="corCategoria(ticket.tipo)"
                    [matTooltip]="coluna.id === 'CONCLUIDO' ? ('Status: ' + labelStatus(ticket.status)) : labelCategoria(ticket.tipo)">
                    {{ labelCategoria(ticket.tipo) }}
                  </span>
                </div>

                <div class="ticket-kanban__flags" *ngIf="estaAtrasado(ticket) || ticket.prioridade">
                  <span class="ticket-kanban__flag ticket-kanban__flag--atraso"
                    *ngIf="estaAtrasado(ticket)" matTooltip="Previsão de entrega vencida">
                    <mat-icon>warning</mat-icon> Atrasado
                  </span>
                  <span class="ticket-kanban__flag"
                    *ngIf="ticket.prioridade"
                    [style.background]="corPrioridade(ticket.prioridade)">
                    {{ labelPrioridade(ticket.prioridade) }}
                  </span>
                </div>

                <p class="ticket-kanban__assunto" [matTooltip]="ticket.menu">
                  {{ ticket.menu || 'Sem assunto' }}
                </p>

                <div class="ticket-kanban__meta">
                  <span>{{ nomeParceiro(ticket) }}</span>
                  <span class="ticket-kanban__tempo" matTooltip="Tempo gasto">
                    <mat-icon>timer</mat-icon>
                    {{ tempoGastoFormatado(ticket) }}
                  </span>
                </div>

                <div class="ticket-kanban__meta ticket-kanban__meta--detalhe">
                  <span matTooltip="Segmento">
                    <mat-icon>category</mat-icon>
                    {{ labelSegmento(ticket.segmento) }}
                  </span>
                  <span class="ticket-kanban__resp" [matTooltip]="'Responsável: ' + nomeResponsavel(ticket)">
                    <span class="ticket-kanban__avatar">{{ iniciaisResponsavel(ticket) }}</span>
                    {{ nomeResponsavel(ticket) }}
                  </span>
                </div>

                <div class="ticket-kanban__status-real" *ngIf="coluna.id === 'CONCLUIDO'"
                  [matTooltip]="'Status real: ' + labelStatus(ticket.status)">
                  {{ labelStatus(ticket.status) }}
                </div>
              </article>

              <p class="ticket-kanban__vazio" *ngIf="!coluna.tickets.length">
                Arraste tickets para cá
              </p>
            </div>
          </section>
        </div>

        <ng-template #loading>
          <div class="ticket-kanban__loading">Carregando quadro...</div>
        </ng-template>
      </mat-card>
    </div>
  </div>
</main>

<ng-template #dialogMotivo>
  <h2 mat-dialog-title>Alterar status do ticket</h2>
  <mat-dialog-content class="ticket-kanban__dialog" *ngIf="movimentoPendente as mov">
    <p class="ticket-kanban__dialog-resumo">
      Ticket <strong>#{{ mov.ticket.id }}</strong><br>
      De <strong>{{ labelStatus(mov.statusAnterior) }}</strong>
      para <strong>{{ mov.escolherStatusConcluido ? 'Concluído' : mov.labelDestino }}</strong>
    </p>

    <mat-form-field appearance="fill" class="full-width" *ngIf="mov.escolherStatusConcluido">
      <mat-label>Status de conclusão</mat-label>
      <mat-select [(ngModel)]="statusConcluidoEscolhido">
        <mat-option *ngFor="let st of opcoesStatusConcluido" [value]="st">
          {{ labelStatus(st) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Motivo da alteração</mat-label>
      <textarea matInput [(ngModel)]="alteracaoMotivo" rows="3" required
        (keydown)="onMotivoKeydown($event)"></textarea>
      <mat-hint>Ctrl+Enter para confirmar</mat-hint>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="cancelarMudancaStatus()" [disabled]="movendo">
      Cancelar
    </button>
    <button mat-raised-button color="primary" type="button"
      (click)="confirmarMudancaStatus()" [disabled]="movendo">
      Confirmar
    </button>
  </mat-dialog-actions>
</ng-template>
